import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from '../Program.css';

class Option extends Component {
  render() {
    return (
      <div
        onClick={this._onClick}
        className={`${styles['option-container']} text-center ${
          this.props.isDisabled ? styles['option-container-disabled'] : ''
        }`}
      >
        <div className={styles['option-img-container']}>
          <img src={this.props.img} className={styles['option-img']} />
        </div>
        <div className={`${styles['option-title']}`}>{this.props.title}</div>
        <div className={`${styles['option-body']}`}>{this.props.body}</div>
      </div>
    );
  }

  _onClick = () => {
    const { onClick, earningRuleType } = this.props;
    if (onClick) {
      this.props.onClick(earningRuleType);
    }
  };
}

Option.propTypes = {
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.string,
};

export default Option;
